  <template>
  <ValidationObserver ref='validationObserver'>
    <a v-if="editing" href='#' @click="goTo({path: '/mf/minhas-doacoes', event: 'listDonations' })" class='back-button'> <font-awesome-icon title='Voltar' icon="fa-arrow-left" /> </a>
    <div>
      <div class="new-form-row">
        <h3 class="new-form-legend">Doação</h3>
      </div>
      <div class="new-form-row">
        <p class="new-form-text">Selecione o valor:</p>
      </div>
      <div class="new-form-row">
        <ValidationProvider rules='required' v-slot="{ errors }">
          <div class="new-form-group-radio">
             <div class="new-form-radio" v-for="donationValue in donationValues">
              <input
                type="radio"
                data-cy="amount"
                name="amount"
                v-model="form.amount"
                @click="deactivateOther"
                :value=donationValue.amount
                :id="'amount'+donationValue.amount"
              >
              <label :for="'amount'+donationValue.amount">{{numberToReal(donationValue.amount)}}</label>
            </div>
            <div class="new-form-radio">
              <input
                type="radio"
                data-cy="amount"
                name="amount"
                :checked="otherValue"
                @click="activateOther"
                id="amount-other"
              >
              <label for="amount-other">Outro valor</label>
            </div>
          </div>
          <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="new-form-row" v-if="otherValue">
        <ValidationProvider rules='required' v-slot="{ errors }">
          <div class="new-form-input">
            <input
              type="number"
              name="amount"
              placeholder="Outro valor"
              v-model="form.amount"
            >
          </div>
        </ValidationProvider>
        <ValidationProvider rules='required_if:outro,true' v-slot="{ errors }">
          <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="new-form-row">
        <ValidationProvider rules="required|oneOf:0,1" v-slot="{ errors }">
          <div class="new-form-group-radio">
            <div class="new-form-radio">
              <input
                type="radio"
                data-cy="recurring"
                name="recurring"
                v-model="form.recurring"
                value="1"
                id="recurring-1"
                :disabled="!!editing"
              >
              <label for="recurring-1">Doação recorrente</label>
            </div>
            <div class="new-form-radio">
              <input
                type="radio"
                data-cy="recurring"
                name="recurring"
                v-model="form.recurring"
                value='0'
                id="recurring-2"
                :disabled="!!editing"
              >
              <label for="recurring-2">Doação única</label>
            </div>
          </div>
          <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>
    <div class="new-form-controls" v-if="this.editing">
      <div class="new-form-control">
        <button
          @click="update"
          class="new-form-button new-form-button-primary"
        > Atualizar
        </button>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>

import { setupAxios } from '../../setupAxios';
import { getDonation, updateDonation, getDonationValues } from '../../apiClient';
import { numberToReal } from '../../../../helpers';

export default {
  name: 'ValueForm',
  props: {
    admin: { type: Boolean, default: false },
    editing: { type: Boolean, default: false },
    donationId: { type: Number },
    formData: {
      amount: { type: Number },
      recurring: { type: Boolean }
    }
  },
  data: function () {
    return {
      donation: undefined,
      otherValue: false,
      form: this.formData ? this.formData : { amount: '', recurring: '' },
      donationValues: [
        { id: 1, amount: 15 },
        { id: 2, amount: 20 },
        { id: 3, amount: 30 },
        { id: 4, amount: 100 }
      ]
    };
  },
  async mounted () {
    this.axios = setupAxios(this.getValidationObserver());
    this.donationValues = (await getDonationValues(this.axios)).data.sort((a, b) => a.amount - b.amount);
    if (this.editing) {
      const donationId = this.donationId ? this.donationId : this.$route.params.id;
      const { data: donation } = await getDonation(this.axios, donationId);
      this.donation = donation;
      this.form.amount = donation.amount;
      this.form.recurring = donation.recurring;
      this.otherValue = !this.donationValues.find(d => d.amount === donation.amount);
    }
  },
  methods: {
    validForm: async function () {
      return this.$refs.validationObserver.validate();
    },
    activateOther () {
      this.otherValue = true;
    },
    deactivateOther () {
      this.otherValue = false;
    },
    getValidationObserver () {
      return this.$refs.validationObserver;
    },
    async update () {
      const data = {
        amount: this.form.amount
      };


      const res = await updateDonation(this.axios, this.donation.id, data);
      console.log('res', res);

      if (res) {
        alert('Dados atualizados!!!');
      }
    },
    goTo (params) {
      if (this.admin) {
        this.$emit(params.event, { event: params.event });
      } else {
        this.$router.push({ path: params.path });
      }
    },
    numberToReal (n) {
      return numberToReal(n);
    }
  }
};
</script>
